import { Injectable, inject } from '@angular/core';

import { AppInfoConfig } from '@frontend/vanilla/core';

import { ChannelType } from '../config/appConstants';
import { QuickDepositMessageService } from './quick-deposit-message.service';

@Injectable({
    providedIn: 'root',
})
export class ResizeService {
    private appInfo = inject(AppInfoConfig);
    private quickDepositMessageService = inject(QuickDepositMessageService);

    resizeCashier() {
        let height = this.outerHeight('.quick-deposit-feature') || 250;
        height = [ChannelType.MW, ChannelType.AW, ChannelType.IW].includes(this.appInfo.channel) ? height + 45 : height;
        this.quickDepositMessageService.sendOutput('action=resize&width=320&height=' + (height + 13));
    }

    outerHeight(el: any) {
        const my_element = document?.querySelector(el);
        if (my_element) {
            const style = window?.getComputedStyle(my_element);
            return my_element?.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        }
    }
}
